import { createEntityHooks } from "../../common/entity";
import contactTypeState from "./state";

export const { useEntities: useContactTypes, useEntity: useContactType } =
  createEntityHooks({
    entity: contactTypeState.entity,
    actions: contactTypeState.actions,
  });
